var Block = {
	top: 0,
	show: 0,
	id: ""
}
var blocks = [];
var Indnav = {
	top: 0,
	btm: 0,
	height: 0
}
var isFired = false;
var indnavs = [];
var wheelTimer;
var wheel = {
	canScroll: true,
	isTouch: false,
	count: 0,
	flag: true,
	init: function(){
		wheel.resize();
		$(document).on("scroll", function(e){
			wheel.scrl();
		});
	},
	noScrl: function(){
		$("body").off("mousewheel");
	},
	activeScrl: function(){
		var $body = $("body");
		if(isIPad){ return false}
		var callback = function (delta) {
			if(!wheel.canScroll){ 
				return false
			}else{
				wheel.canScroll = false;
				//wheel.canScroll = false;
			}
			if(delta >= 1) {
				wheel.count--;
				delta = 0;
				if(wheel.count < 0){
					wheel.count = 0;
				}
				setTimeout(function(){
					wheel.move(wheel.count);
				},100);
			}else if(delta < 0){
				wheel.count++;
				delta = 0;
				if(wheel.count >= $("#dmy li").length){
					wheel.count = $("#dmy li").length-1;
				}
				setTimeout(function(){
					wheel.move(wheel.count);
				},100);
			}else{
				wheel.canScroll = true;
			}
		};
		
		var timer;
		var interval = 250;
		var last_time = 0,
			delta = 0,
			uintDelta = 0;
			callback.delta = 0;

		var MOUSE_WHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
		//ホイールイベントを検知
		$(document).off(MOUSE_WHEEL_EVENT).on(MOUSE_WHEEL_EVENT, function(e){
			e.preventDefault();
			changeDelta(e);
		});
		
		function changeDelta(e){
			var now = new Date().getTime();
			var diff = now - last_time;
			delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail); 
			if (!delta) { return;}
			uintDelta = Math.abs(delta);
			if (uintDelta - callback.delta > 0) {
				//増加
				if (diff > interval && !isFired){
					callback(delta);
					isFired = true;
				}
				last_time = now;
			}else{
				//減退
				isFired = false;
			}
			callback.delta = uintDelta;
		}
	},
	nav: function(){
		$("#block-indicator li a").off().on("click", function(){
			let $this = $(this);
			if(wheel.flag){
				var idx = $("#block-indicator li a").index(this);
				wheel.count = parseInt(idx) + 1;
				wheel.move(wheel.count);
				let label 		= $this.attr("data-ga");
				let category 	= $this.attr("data-category");
				let action 		= $this.attr("data-action");
				common.sendClickGa(label, category, action);
			}
		});
		if(isSP || isIPad){
			var lastTouchY = lastTouchY || 0,
				positionY,cy, isOver, topD,
				limit = 80;
			$("body").off().on({
				'touchstart': function(e) {
					cy 			= 0;
					positionY 	= getPosition(e);
				},
				'touchmove': function(e) {
					cy 	= positionY - getPosition(e);
				},
				'touchend': function(e) {
					positionY = 0;
					if(wheel.canScroll){
						wheel.canScroll = false;
						if(cy <= -limit){
							wheel.count--;
							if(wheel.count < 0){
								wheel.count = 0;
							}
							wheel.move(wheel.count);
						}else if(cy > limit){
							//console.log("touchend:",isIPad,wheel.canScroll, cy,limit,wheel.count)
							wheel.count++;
							if(wheel.count >= $("#dmy li").length){
								wheel.count = $("#dmy li").length-1;
							}
							wheel.move(wheel.count);
						}else{
							cy = 0;
							wheel.canScroll = true;
						}
					}
					
				},
				'touchcancel': function(e){
					cy = 0;
					wheel.canScroll = true;
				}
			});
		}else{
			wheel.activeScrl();
		}
		function getPosition(event){
			return event.touches[0].pageY;
		}
	},
	resize: function(){
		blocks = [];
		indnavs = [];
		let allH = 0;
		let winH = $(window).height();
		$("#dmy ul li.db").each(function(i){
			var _b 	= object(Block);
			var $this = $(this);
			_b.top 	= Math.floor($this.offset().top);
			_b.show = Math.floor(_b.top + $(window).height());
			_b.id 	= $this.attr("data-id");
			blocks.push(_b);
			$this.css({
				"height": winH + "px"
			});
			$(".b").eq(i).css({
				//"height": winH + "px"
			});
			var _i = object(Indnav);
			_i.top = _b.top;
			_i.height = $this.height();
			_i.btm = _i.top + _i.height;
			indnavs.push(_i);
		});
		//console.log(indnavs)
		$("#dmy .f").css({
			"height": $("footer").outerHeight() + "px"
		});
		var totalH = 0;
		var _h = $(window).height();
		$(".b").each(function(i){
			/*$(this).css({
				"top": _h*(i+1) + "px"
			});*/
			totalH += _h;
		});
		if(isIE11){
			$("#wrap").css("height", totalH + "px");
		}
		//$("#wrap").css("height", totalH + "px");
	},
	scrl: function(){
		var topD 	= $(document).scrollTop(),
			btmD 	= topD + $(window).height(),
			len 	= blocks.length;
		if(!isSmallScreen && !isIPad){
			for(var i = 0; i < len; i++){
				if(i === len - 1){
					if(topD >= blocks[i].top){
						wheel.move(i);
					}
				}else{
					if(topD >= blocks[i].top && topD < blocks[i+1].top){
						wheel.move(i);
					}
				}
			}
		}
	},
	move: function(i){
		let $blk = $(".db").eq(i),
			$body = $("body");
		if(!$blk.hasClass("active")){
			//モーダルのナビが出現している時はスクロールさせない
			if($body.hasClass("nav")){ return false;}
			//console.log(wheel.count)
			wheel.noScrl();
			wheel.count = i;
			$(".db").removeClass("active");
			$blk.addClass("active");
			$body.removeClass(function(index, className) {
				return (className.match(/\bactive\S+/g) || []).join(' ');
			});
			$body.addClass("active" + i);
			if(wheel.count !== 0){
				if(!$("#kv").hasClass("disable")){
					$("#kv").addClass("disable");
				}
			}
			//console.log(wheel.count)
			if(wheel.count === 4){
				players[0].play();
				//console.log("here")
				var story1player = $("#video-story1_html5_api");
				if(!story1player.hasClass("played")){
					story1player.addClass("played");
					common.sendClickGa("start", "story1_motion", "play");
				}
			}else{
				players[0].pause();
			}
			setTimeout(function(){
				$(".b").removeClass("active");
				$("#" + blocks[wheel.count].id).addClass("active");
				var dataga = $("#" + blocks[wheel.count].id).attr("data-ga");
				if(dataga != ""){
					if(isFirst){
						isFirst = false;
					}else{
						common.sendScrollPageGa(dataga);
					}
				}
				if(wheel.count === 0){
					wheel.isTop();
				}
			},400);
			setTimeout(function(){
				wheel.flag = true;
				//wheel.activeScrl();
			},800);
		}
		setTimeout(function(){
			wheel.canScroll = true;
			isFired = false;
		}, 1200)
	},
	isTop: function(){
		var $body 	= $("body"),
			$kv 	= $("#kv");
		$kv.removeClass("show disable active");
		setTimeout(function(){
			$kv.addClass("active");
			setTimeout(function(){
				$kv.addClass("show");
			},100)
		}, 50);
	}
}